import { REMOTE_CONFIG_URL } from "@/config/remoteConfig";

let apiBaseUrl = "";
let apiReady = false;
let resolvingPromise = null;

function buildApiBaseUrl(apiUrl) {
  const trimmed = String(apiUrl || "").trim();
  if (!trimmed) return "";

  let base = trimmed.replace(/\/+$/, "");
  if (/\/api$/i.test(base)) {
    return `${base}/`;
  }
  return `${base}/api/`;
}

function decodeConfigText(text) {
  const raw = String(text || "").trim();
  if (!raw) return "";

  if (raw.startsWith("{") || raw.startsWith("[")) {
    return raw;
  }

  try {
    const decoded = atob(raw);
    if (decoded.trim()) {
      return decoded.trim();
    }
  } catch (error) {
    // ignore invalid base64
  }

  return raw;
}

function parseRemoteConfig(text) {
  const jsonText = decodeConfigText(text);
  if (!jsonText) return "";

  try {
    const config = JSON.parse(jsonText);
    const apiUrl =
      config.apiurl || config.apiUrl || config.APIURL || config.API_URL;
    if (apiUrl) {
      return buildApiBaseUrl(apiUrl);
    }
  } catch (error) {
    console.error("远程配置 JSON 解析失败：", error, jsonText);
  }

  return "";
}

export function isApiBaseReady() {
  return apiReady;
}

export function getStoredApiBaseUrl() {
  return apiBaseUrl;
}

function setApiBaseUrl(url) {
  apiBaseUrl = buildApiBaseUrl(url.replace(/\/api\/?$/i, ""));
  apiReady = true;
  return apiBaseUrl;
}

export function resetApiBase() {
  apiBaseUrl = "";
  apiReady = false;
  resolvingPromise = null;
}

async function fetchRemoteConfig() {
  const configUrl = `${REMOTE_CONFIG_URL}${REMOTE_CONFIG_URL.includes("?") ? "&" : "?"}t=${Date.now()}`;

  const response = await fetch(configUrl, {
    method: "GET",
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Remote config fetch failed: ${response.status}`);
  }

  const text = await response.text();
  const resolved = parseRemoteConfig(text);

  if (!resolved) {
    throw new Error("Failed to parse API base URL from remote config");
  }

  return setApiBaseUrl(resolved);
}

export function resolveApiBaseUrl() {
  if (apiReady && apiBaseUrl) {
    return Promise.resolve(apiBaseUrl);
  }

  if (resolvingPromise) {
    return resolvingPromise;
  }

  resolvingPromise = fetchRemoteConfig().finally(() => {
    resolvingPromise = null;
  });

  return resolvingPromise;
}
